import { HubItemMediaPreviewViewModel } from "client/Api/Hub/common";
import { EventListItem } from "client/Features/Hub/Events/ListItem/EventListItem";
import { ReactElement, useMemo } from "react";
import { convertHubMedia } from "client/Features/Search/RecentSearch/Persistence/convertPersistedData";
import { TimeZone } from "client/DateAndTime/timezones";
import { generateTrackingId } from "client/Misc/utils";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import { GlobalSearchResultItemKind } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { useEventNavigationHandler } from "../../../Navigation/useEventNavigationHandler";
import { ValidGlobalSearchItemPersistedModel } from "client/Features/Search/RecentSearch/Persistence/validation";

export type EventItemViewProps = {
	item: ValidGlobalSearchItemPersistedModel<GlobalSearchResultItemKind.Event>;
	itemIndex: number;
	onRemove: () => void;
	timezone: TimeZone;
	tabIndex: number;
};

export const EventItemView = (props: EventItemViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		onRemove,
		timezone,
		tabIndex
	} = props;

	const {
		id,
		title,
		author,
		category,
		media: persistedMedia,
		startDate
	} = item.event;

	const media = useMemo(
		(): HubItemMediaPreviewViewModel => convertHubMedia(persistedMedia),
		[persistedMedia]
	);

	const openHandler: () => void = useEventNavigationHandler({
		id,
		recentlyOpenedItem: item
	});

	return (
		<GlobalSearchItem
			trackingId={generateTrackingId("event-item", `|${id}`)}
			onClick={openHandler}
		>
			<EventListItem
				title={title}
				authorName={author?.name}
				categoryName={category?.name}
				media={media}
				startDate={startDate}
				timezone={timezone}
				trackingId={generateTrackingId("event-item-result-list-item", `|${id}`)}
				onRemove={onRemove}
				itemIndex={itemIndex}
				tabIndex={tabIndex}
				onExecute={openHandler}
			/>
		</GlobalSearchItem>
	);
};
EventItemView.displayName = "EventItemView";